module.exports = __webpack_public_path__ + "static/media/ACT.3fa7d2f6.jpg";